export default __webpack_public_path__ + "static/media/500.68b28ffe.png";